<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Hide bank account
        </v-card-title>

        <v-card-text light>
          <p><strong>User ID</strong>: <code>{{ userId }}</code></p>
          <p><strong>IBAN</strong>: <code>{{ iban }}</code></p>
          <p><v-divider /></p>
          <p>Are you sure you want to hide the bank account?</p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            flat
            @click="() => { isVisible = false; $emit('submit') }"
          >
            Hide
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'HideBankAccountDialog',
  components: {
  },
  props: {
    visible: Boolean,
    userId: {
      type: String,
      required: true,
    },
    iban: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/eie/bankAccounts/dialogs/HideBankAccountDialog.vue